@use "@fukuri-admins/ui/layout" as *;

.Pagination {
  display: flex;
  align-items: center;
  gap: 8px;

  button {
    border: 1px solid $NATURAL_600;
    background-color: $White;
    color: $NATURAL_600;
    display: inline-flex;
    height: 32px;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    border-radius: 4px;
    transition: all 0.2s ease-out;

    svg {
      color: $NATURAL_600;
    }

    &:hover {
      background-color: $NATURAL_100;
    }
    &:disabled {
      cursor: default;
      border: 1px solid $NATURAL_400;
      color: $NATURAL_400;
      svg {
        color: $NATURAL_400;
      }
      &:hover {
        background-color: $White;
      }
    }
  }
  &__PageInfo {
    color: $NATURAL_400;
    font-size: 14px;
    font-weight: 600;
  }
}
